import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModaliteReunion } from 'src/app/shared/models/modaliteReunion';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModaliteReunionModalAjoutComponent } from '../modal/modaliteReunion-modal-ajout/modaliteReunion-modal-ajout.component';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { ModaliteReunionModalDetailComponent } from '../modal/modaliteReunion-modal-detail/modaliteReunion-modal-detail.component';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-modaliteReunion',
	templateUrl: './list-modaliteReunion.component.html',
	styleUrls: ['./list-modaliteReunion.component.scss']
})
export class ListModaliteReunionComponent implements OnInit {
	modaliteReunion: ModaliteReunion[] = [];
	currentPage = 1;
	itemsPerPage = 10;

	modaliteReunionCsvFile: File = null;
	searchedSkill = '';
	searchedName = '';

	dismissible: true;
	alerts: any[] = [];

	nextWeekNumber: number;

	user: User = null;

	isAddable = false;
	isImportable = false;

	sortType = 'firstName';
	sortOrder: SortOrder = 'asc';

	searchedText: string;

	editModaliteReunionModalRef: BsModalRef;
	addModaliteReunionModalRef: BsModalRef;
	screenWidth: number;
	isMobile: boolean = false;

	isListingLoading: boolean = true;

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.user = this.facade.dataStorageService.getUser();
		this.getModaliteReunion();
		this.isAddable = true;
	}

	getModaliteReunion(): void {
		this.isListingLoading = true;
		this.facade.modaliteReunionService.getAllModaliteReunion().subscribe({
			next: (val) => {
				this.modaliteReunion = val.filter((e) => e.name !== 'Sans');
				this.itemsPerPage = this.modaliteReunion.length >= 8 ? 10 : 8;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.logger.error(err + '');
				this.isListingLoading = false;
				this.modaliteReunion = [];
			}
		});
	}

	selectModaliteReunion(modaliteReunion: ModaliteReunion): void {
		const link = ['/modaliteReunion', modaliteReunion.id];
		this.router.navigate(link);
	}

	importModaliteReunion(event: any): void {
		this.modaliteReunionCsvFile = event.target.files[0];

		this.facade.modaliteReunionService
			.importModaliteReunion(this.modaliteReunionCsvFile)
			.subscribe({
				next: (importStats: ImportResponse) => {
					this.alerts.push({
						type: 'success',
						msg: `${importStats.entitiesAdded} modaliteReunion ont été ajoutés,
                  ${importStats.entitiesBeforeImport} étaient déjà présents.`
					});

					this.getModaliteReunion();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.logger.error(
						'' + err.status + ' ' + err.error.message ? err.error.message : ''
					);
				}
			});
	}

	onClosed(dismissedAlert: any): void {
		this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		this.addModaliteReunionModalRef = this.modalService.show(
			ModaliteReunionModalAjoutComponent,
			{
				class: 'modal-lg',
				backdrop: 'static'
			}
		);

		this.addModaliteReunionModalRef.onHide.subscribe((reason: string | any) => {
			this.getModaliteReunion();
		});
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	openModalEdit(modaliteReunion: ModaliteReunion) {
		const initialState = {
			modaliteReunion: modaliteReunion
		};
		this.editModaliteReunionModalRef = this.modalService.show(
			ModaliteReunionModalDetailComponent,
			{
				class: '',
				initialState
			}
		);

		this.editModaliteReunionModalRef.onHide.subscribe((reason: string | any) => {
			this.getModaliteReunion();
		});
	}
}
